export default __webpack_public_path__ + "static/media/Animals10.a5a44ef7.jpg";